import React from "react";
import { compose } from "recompose";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Formik, Field } from "formik";
import Yup from "yup";
import { CustomInput, ErrorField } from "components/form";
import { passwordResetWorker } from "ducks/auth/actions";
import logo from "assets/images/im_logo2.png";

const propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({}),
  }).isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  reset: PropTypes.func.isRequired,
};

class PasswordReset extends React.Component {
  constructor(props) {
    super(props);

    this.initialData = {
      email: "",
    };

    this.validationSchema = Yup.object().shape({
      email: Yup.string().required("To pole jest wymagane"),
    });

    this.state = { success: false };
  }

  handleSubmit = async (values, { setErrors, setSubmitting }) => {
    try {
      await this.props.reset(values);
      this.setState({ success: true });
    } catch ({ error }) {
      setErrors(error);
      setSubmitting(false);
    }
  };

  render() {
    if (this.state.success) return <SuccessPanel />;

    return (
      <Formik
        initialValues={this.initialData}
        validationSchema={this.validationSchema}
        onSubmit={this.handleSubmit}
        render={({ errors, handleSubmit, isSubmitting }) => (
          <div className="body login-page-wrapper">
            <div className="image-container">
              <div className="im-logo-container">
                <img src={logo} alt="" />
              </div>
            </div>
            <div className="form-container">
              <div className="form-container-inner">
                <div className="form-heading">
                  <h3>Odzyskiwanie hasła</h3>
                  <h5>innovative thinking, global perspective</h5>
                </div>
                <form action="#" onSubmit={handleSubmit}>
                  <Field
                    name="email"
                    label="email"
                    type="email"
                    component={CustomInput}
                    autoFocus
                  />
                  <div className="btn-container">
                    <button className="full-btn" type="submit" disabled={isSubmitting}>
                      Wyślij
                    </button>
                  </div>
                  <ErrorField text={errors.message} />
                </form>
              </div>
            </div>
          </div>
        )}
      />
    );
  }
}

const mapDispatch = {
  reset: passwordResetWorker,
};

PasswordReset.propTypes = propTypes;
const enhance = compose(connect(null, mapDispatch));

export default enhance(PasswordReset);

const SuccessPanel = () => (
  <div className="body login-page-wrapper">
    <div className="image-container">
      <div className="im-logo-container">
        <img src={logo} alt="" />
      </div>
    </div>
    <div className="form-container">
      <div className="form-container-inner">
        <div className="form-heading">
          <h3>Odzyskiwanie hasła</h3>
          <h5>innovative thinking, global perspective</h5>
          <h5>
            Na podany adres email została wysłana wiadomość. Proszę postępować według zawartych w
            niej instrukcji.
          </h5>
        </div>
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/password/Reset.jsx